<template>
  <b-sidebar
    id="sidebar-sideMenu"
    no-header
    right
    backdrop
    bg-variant="main"
    width="267px"
    class="side_navigation"
    v-model="sidebarOpen"
  >
    <NavigationList :showAds="false" />
    <hr />
    <div class="mb-5 pb-5">
      <Lang sidebar class="p-1 pt-3" />

      <hr class="mb-3" />

      <div class="font-weight-600 text-center mb-3">
        {{ $t("my_representations") }}
      </div>

      <div class="ml-2" v-if="representation.length">
        <a
          href="#"
          class="d-block m-2 align-top"
          v-for="item in representation"
          :key="item.id"
          @click="changeRepresentation(item.id, item.role.id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-person-fill-check"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
            />
            <path
              d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4"
            />
          </svg>
          {{ item.display_name }}
        </a>
      </div>
      <div v-else>
        <div class="disabled text-center text-muted">
          {{ $t("representations_none") }}
        </div>
      </div>

      <hr class="mt-3 mb-3" />

      <b-button
        v-if="mxUserEdit"
        size="lg"
        variant="link"
        class="pl-3 pr-4 d-block side_navigation__buttonLink"
        @click="redirectToProfile"
      >
        <Icon name="account" variant="outline" font-scale="1.1"> </Icon>
        {{ $t("my_profile") }}
      </b-button>
      <b-button
        variant="link-outline"
        size="lg"
        class="pl-3 mt-3 d-block side_navigation__buttonLink"
        @click="logOut"
      >
        <Icon name="logout" variant="outline" font-scale="1.1"> </Icon>
        {{ $t("logout") }}
      </b-button>
    </div>
  </b-sidebar>
</template>
<script>
import Icon from "@/components/Icon/Icon";
import Lang from "@/components/Lang";
import { ROUTE_NAMES, ROUTES } from "@/constants/routeConstants";
import { mapGetters } from "vuex";
import NavigationList from "@/components/Navigation/NavigationList.vue";
export default {
  name: "SideNavigation",
  components: { Icon, Lang, NavigationList },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      active_role: "user/active_role",
      representation: "user/representation",
    }),
    sidebarOpen: {
      get() {
        return this.$store.getters["system/sideBarOpen"];
      },
      set(newValue) {
        return this.$store.commit("system/setSideBarOpen", newValue);
      },
    },
  },
  watch: {
    sidebarOpen() {
      document.querySelector(".page__header").style.zIndex = this.sidebarOpen
        ? 2000
        : 0;
      document.querySelector("body").style.overflow = this.sidebarOpen
        ? "hidden"
        : "auto";
    },
  },
  methods: {
    async logOut() {
      await this.$http.get("logout");
      await this.$store.dispatch("auth/logout");
      await this.$router.push(ROUTES.login);
    },
    async changeRepresentation(user_id, role_id) {
      await this.$store.dispatch("representation/changeRepresentation", {
        user_id: user_id,
        role_id: role_id,
      });
      this.$router.push({ name: ROUTE_NAMES.dashboard });
    },
    redirectToProfile() {
      this.$router.push({ name: ROUTE_NAMES.profile });
    },
  },
};
</script>
